import { PauseIcon, PlayIcon } from "@heroicons/react/solid";
import * as React from "react";
import { useState, useEffect } from "react";
import WordCloudChart from "../charts/wordcloud";
import { getJSONData } from "../utils";

const Clouds = ({ data }) => {
  const [selected, setSelected] = useState(0);
  const [playStatus, setPlayStatus] = useState(false);
  const [wordCloudData, setWordCloudData] = useState([]);

  useEffect(() => {
    const id = setInterval(() => {
      // console.log("intere...", selected + 1);
      // setSelected((selected + 1) % data.length);
      if (playStatus) {
        setSelected((selected + 1) % data.length);
      }
    }, 3000);
    return () => {
      // console.log("clearning interval");
      clearInterval(id);
    };
  }, [selected, playStatus, data.length]);

  useEffect(() => {
    asyncFetch();
  }, []);
  const asyncFetch = () => {
    const getEvents = getJSONData(
      `${process.env.GATSBY_PATH_PREFIX}/data/wordcloud.json`
    );
    getEvents.then((data) => {
      setWordCloudData(data);
    });
  };

  const toDateString = (date) => {
    const d = new Date(date);
    return d.toDateString();
  };

  const selector = data.map((data, i) => {
    return (
      <div
        role={"button"}
        tabIndex={0}
        onClick={() => {
          setPlayStatus(false);
          setSelected(i);
        }}
        onKeyDown={() => {
          setPlayStatus(false);
          setSelected(i);
        }}
        className={
          "borpder hover:bg-indigo-100 hover:cursor-pointer inline-block p-1 px-2 rounded border-t-2 " +
          (selected === i
            ? " bg-indigo-100  border-indigo-500  "
            : "bg-gray-50 border-gray-50")
        }
        key={"selectorrow" + i}
      >
        <div className="font-semibold">{toDateString(data.date)}</div>
        <div className="text-sm">{data.event}</div>
      </div>
    );
  });

  const playButtonClicked = () => {
    if (playStatus) {
      // clearInterval(intervalId);
      setPlayStatus(false);
      setSelected(0);
    } else {
      setSelected((selected + 1) % data.length);
      setPlayStatus(true);
    }
  };
  // console.log((((selected + 0.1) / data.length) * 100).toFixed(1) + "px");
  const buttonClasses =
    "w-8 hover:text-indigo-800 transition duration-500 inline-block text-indigo-600";
  return (
    <div>
      <div className="flex flex-row mb-4">
        <div
          role={"button"}
          onClick={() => {
            playButtonClicked();
          }}
          tabIndex={0}
          onKeyDown={() => {
            playButtonClicked();
          }}
          className="mr-4 border border-indigo-500 rounded px-3 pb-1 bg-indigo-100 hover:bg-indigo-200 hover:cursor-pointer text-sm pt-1"
        >
          {playStatus ? (
            <span>
              {" "}
              <PauseIcon className={buttonClasses} /> Pause Timeline
            </span>
          ) : (
            <span>
              <PlayIcon className={buttonClasses} /> Re-Play Timeline
            </span>
          )}
        </div>
        <div className="flex flex-1 bg-gray-50 pt-2 rounded px-3   flex-row">
          <div className="pr-2">Sep 2018</div>
          <div className="flex-1 ">
            <div className="flex-1 mt-2 rounded bg-gray-300 h-2">
              <div
                style={{
                  width:
                    (((selected + 0.1) / data.length) * 100).toFixed(1) + "%",
                }}
                className="flex-1   mt-2 rounded bg-indigo-600 h-2"
              ></div>
            </div>
          </div>
          <div className="px-2">March 2019</div>
        </div>
      </div>
      <div className="block md:flex gap-2">
        {data.length > 0 && (
          <div className="flex-1 border-t-2 rounded border-indigo-500  ">
            <div className=" mb-1  pt-1">
              <span className="font-semibold text-2xl">
                {" "}
                {toDateString(data[selected]["date"])}{" "}
              </span>
              Read related news
              <a
                className="ml-2 text-normal "
                target={"_blank"}
                rel="noreferrer"
                href={data[selected]["link"]}
              >
                article
              </a>
              .{" "}
            </div>
            <div className="mb-3">{data[selected]["description"]}</div>

            <div className="boprder rounded mb-2">
              <WordCloudChart data={wordCloudData[data[selected].date]} />{" "}
            </div>
          </div>
        )}
        <div className="flex-auto gap-2">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
            {selector}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Clouds;
